import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {tap} from "rxjs/operators";
import {ExecutionResultModel} from "../../models/api/execution-result.model";
import {LoggerService} from "../logger.service";

@Injectable({
    providedIn: "root"
})
export class ApiService {
    private get DEFAULT_ERROR_MESSAGE(): string {
        return "An error has occurred. Please try again or contact the system administrator if the problem persists.";
    }

    public constructor(
        private http: HttpClient,
        private logger: LoggerService,
    ) {

    }

    public get<TResult>(url: string, params: any | null): Observable<TResult> {
        let http = this.http.get<TResult>(url, {params: params});
        http = this.appendLoggerToFlow(http, url, params);

        return http;
    }

    public post<TResult>(url: string, body: any | null): Observable<TResult> {
        let http = this.http.post<TResult>(url, body);
        http = this.appendLoggerToFlow(http, url, body);

        return http;
    }

    public executeGet<TResult>(url: string, params: any | null): Observable<ExecutionResultModel<TResult>> {
        const http = this.get<ExecutionResultModel<TResult>>(url, params);
        return http;
    }

    public executePost<TResult>(url: string, body: any | null): Observable<ExecutionResultModel<TResult>> {
        const http = this.post<ExecutionResultModel<TResult>>(url, body);
        return http;
    }

    private appendLoggerToFlow<TResult>(http: Observable<TResult>, url: string, params: any | null = null,  body: any | null = null): Observable<TResult> {
        const stackTrace = { stack: "" };

        if (Error.captureStackTrace) {
            Error.captureStackTrace(stackTrace, this.appendLoggerToFlow);
        } else {
            const error = new Error();
            if(error.stack) {
                stackTrace.stack = error.stack;
            }
        }

        return http.pipe(
            tap(response => {
                this.logger.debug(`API method call: "${url}"`, {
                    request: {
                        url: url,
                        params: params,
                        body: body
                    },
                    response: response,
                    stackTrace: stackTrace.stack
                        .split("\n")
                        .filter(x => x.includes("../ts/app"))
                        .splice(1, 10)
                });
            })
        );
    }
}
